var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.631,
    height: 46.227,
    viewBox: "0 0 45.631 46.227",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;stroke-miterlimit:10;stroke-width:2px;}.a{stroke:#40b895;}.b{stroke:#4f4f4f;stroke-linecap:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M193.79,91.62H212.6",
    transform: "translate(-179.493 -91.62)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 7.441,
    transform: "translate(21.392 0.612)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 7.975,
    transform: "translate(26.427 0.612)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M179.263,160.887v12.005c0,3.075-11.194,1.54-11.194,0v-6.4H143.09v-11.2h30.577c.074,0,.147,0,.221.007a5.61,5.61,0,0,1,5.375,5.59Z",
    transform: "translate(-135.632 -146.703)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M95.247,124.572v13.5a3.729,3.729,0,0,1-7.457,0v-13.5a3.746,3.746,0,0,1,3.732-3.732,3.742,3.742,0,0,1,3.725,3.732Z",
    transform: "translate(-87.79 -116.899)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M335.247,346.842c-3.078-3.078,3.544-10.182,3.544-10.182s6.622,7.1,3.544,10.182a3.058,3.058,0,0,1-1.192.619,7.763,7.763,0,0,1-4.706,0A3.053,3.053,0,0,1,335.247,346.842Z",
    transform: "translate(-301.166 -303.611)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.2007d5b4f7ab9ef8fc54cecb8ef6a56f.svg";
export { ForwardRef as ReactComponent };